import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { HiMenu, HiX } from 'react-icons/hi'; // For menu icon
import { useAuth } from '../utils/AuthContext'; // Corrected import path

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // State for mobile menu
  const navigate = useNavigate();
  const { isAuthenticated, logout } = useAuth();

  const handleLogout = () => {
    logout(); // Use the logout function from AuthContext
    navigate('/login');
  };

  // Get current window width to conditionally render elements for mobile/desktop
  // This is a workaround assuming Tailwind's responsive classes aren't working as expected
  // In a real app, you'd typically rely solely on Tailwind for this.
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = windowWidth < 768; // Assuming 'md' breakpoint is 768px

  return (
    <nav className="w-full bg-white/80 backdrop-blur-sm shadow-sm px-4 py-3 flex justify-between items-center font-[Poppins] fixed top-0 left-0 z-40 md:px-6 md:py-4">
      <Link to="/" className="text-xl text-blue-600 tracking-tight hover:text-blue-800 transition-all md:text-2xl" style={{ letterSpacing: '0.02em' }}>
        ExpenseTracker
      </Link>

      {isMobile ? (
        <>
          {/* Mobile menu button */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 hover:text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md p-2">
              {isOpen ? <HiX className="h-6 w-6" /> : <HiMenu className="h-6 w-6" />}
            </button>
          </div>

          {/* Mobile menu content */}
          {isOpen && (
            <div className="absolute top-full left-0 w-full bg-white/90 backdrop-blur-sm shadow-lg py-4 md:hidden">
              <div className="flex flex-col items-center gap-4">
                {!isAuthenticated ? (
                  <>
                    <Link to="/login" className="block w-full text-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition" onClick={() => setIsOpen(false)}>Login</Link>
                    <Link to="/register" className="block w-full text-center px-4 py-2 text-blue-600 border-t border-blue-200 hover:bg-blue-50 hover:text-blue-700 transition" onClick={() => setIsOpen(false)}>Register</Link>
                  </>
                ) : (
                  <>
                    <Link to="/dashboard" className="block w-full text-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition" onClick={() => setIsOpen(false)}>Dashboard</Link>
                    <Link to="/transactions" className="block w-full text-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition" onClick={() => setIsOpen(false)}>Transactions</Link>
                    <Link to="/add-expense" className="block w-full text-center px-4 py-2 text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition" onClick={() => setIsOpen(false)}>Add Expense</Link>
                    <button onClick={() => { handleLogout(); setIsOpen(false); }} className="block w-full text-center px-4 py-2 text-white bg-blue-600 hover:bg-blue-700 transition">Logout</button>
                  </>
                )}
              </div>
            </div>
          )}
        </>
      ) : (
        /* Desktop navigation */
        <div className="hidden md:flex items-center gap-4">
          {!isAuthenticated ? (
            <>
              <Link to="/login" className="px-3 py-1 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition text-base cursor-pointer">Login</Link>
              <Link to="/register" className="px-3 py-1 rounded-md text-blue-600 border border-blue-200 hover:bg-blue-50 hover:text-blue-700 transition text-base cursor-pointer">Register</Link>
            </>
          ) : (
            <>
              <Link to="/dashboard" className="px-3 py-1 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition text-base cursor-pointer">Dashboard</Link>
              <Link to="/transactions" className="px-3 py-1 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition text-base cursor-pointer">Transactions</Link>
              <Link to="/add-expense" className="px-3 py-1 rounded-md text-gray-700 hover:text-blue-600 hover:bg-gray-100 transition text-base cursor-pointer">Add Expense</Link>
              <button onClick={handleLogout} className="px-3 py-1 rounded-md text-white bg-blue-600 hover:bg-blue-700 transition text-base cursor-pointer">Logout</button>
            </>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
